import Select, { components } from "react-select";
import React, { useState, useEffect, useRef }  from 'react';
export default function SelectItem(props){
        const options = props.options;
        const [menuIsOpen, setMenuOpen] = React.useState(false)
        const selectRef = React.useRef(null);

        const prevOptions = usePrevious(props.options);
        useEffect(() => {
            if((JSON.stringify(props.options) !== JSON.stringify(prevOptions)) && props.name === 'type') {
                onClear();
                props.handleChange('');
            }
            
        });

        const onClear = () => {
            selectRef.current.clearValue();
        };

        function usePrevious(value) {
            const ref = useRef();
            useEffect(() => {
                ref.current = value; //assign the value of ref to the argument
            },[value]); //this code will run when the value of 'value' changes
            return ref.current; //in the end, return the current ref value.
        }

        const DropdownIndicator = (
            props: ElementConfig<typeof components.DropdownIndicator>
          ) => {
            return (
              <components.DropdownIndicator {...props}>
                <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1.5L8 8.5L15 1.5" stroke="black" strokeWidth="2"/>
                </svg>
              </components.DropdownIndicator>
            );
          };
          

        const customStyles = {
            option: (provided, state) => ({
                padding:"0.5rem 0.625rem",
                display: 'block',
                transition: '0.1s cubic-bezier(.7,.33,.25,.87)',
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: '#00AD26',
                    color: 'white'
                }
                
            }),
            menu: (provided, state) => ({
                ...provided,
                backgroundColor: '#EDEDED',
                borderRadius: 0,
                transition: '0.3s cubic-bezier(.7,.33,.25,.87)',
                border: `${!props.validate ? '1px solid #EB5757' : '1px solid transparent'}`,
                borderTop: '1px solid transparent',
                marginTop: '1px',
                padding: '0',
                borderTop: '1px solid white',
                boxShadow: 'none',
                zIndex: '2'
                
            }),

            menuList: (provided, state) => ({
                ...provided,
                padding: '0',
            }),
            valueContainer: (provided, state) => ({
                ...provided,
                padding: '0',
            }),
            control: () => ({
               padding: '1rem 0.625rem !important',
               paddingRight: '0',
               display: 'flex',
               backgroundColor: '#EDEDED',
               alignItems: 'center',
               cursor: 'pointer',
               transition: '0.3s cubic-bezier(.7,.33,.25,.87)',
               fontFamily: `'EuropeCondensedc', 'Loos Light', sans-serif`,
               border: `${!props.validate ? '1px solid #EB5757' : '1px solid transparent'}`,
            }),
            placeholder: (provided, state) => {
                const color = 'black';
                return {...provided, color}
            },
            indicatorsContainer: (styles, { data, isDisabled, isFocused, isSelected }) => ({
                
                height: '100%',
                position: 'relative',
                width: `${window.innerWidth > 1200? '3rem' : '2rem'}`,
                transition: '0.3s cubic-bezier(.7,.33,.25,.87)',
                pointerEvents: 'none',
                transform: menuIsOpen ?  'rotate(180deg)' : '',
                'svg': {
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    height: '0.5rem'
                }
            }),
            singleValue: (provided, state) => ({
                ...provided,
            })
        }

        function changeHandler() {

        }
        return(
            <Select 
                ref={selectRef} 
                components={{DropdownIndicator}} 
                options={options} 
                isSearchable={false}
                styles={customStyles} 
                menuIsOpen={menuIsOpen}
                onChange={props.handleChange}
                placeholder = {props.placeholder}
                onMenuOpen={() => {
                    props.handleChange('');
                    setMenuOpen(true)
                }}
                onMenuClose={() => {
                    setTimeout(() => {
                        if(selectRef.current?.props.value !== null) {
                            props.handleChange(selectRef.current?.props.value);   
                        }
                        else {
                            props.handleChange({value: ''}); 
                        } 
                    }, 100);
                    
                           
                    setMenuOpen(false)
                }}
            />)
}